module.exports = __webpack_public_path__ + "static/media/shield_push.0889ef33.png";